import { o_util } from "../../common/namespaces";
import { assignNamespace } from "../../common/namespace-utils";
import { get, getToggle } from "./get.js";

export * from "./get.js";

/*                    */
assignNamespace(o_util, "toggle", { get, getToggle });
